import styled from 'styled-components';
import { Card, Tooltip } from '@mui/material';

export const TooltipStyled = styled(Tooltip)`
  display: flex;
  align-items: center;
`;

export const TextTipStyled = styled.p`
  font-size: 13px;
  margin-left: 5px;
  text-decoration: underline;
  margin: none;
  color: #000;
`;

export const CardStyled = styled(Card)`
  padding: 19px;
  display: flex;
  border-radius: 50px 0 0 0;
  align-items: center;
  flex-direction: column;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  p {
    margin: 0 17px 11px;
    font-size: 13px;
    line-height: 22px;
  }
`;
